import { environment } from "apps/snmp-api/src/environments/environment";
import { DDMService } from "./ddm.service";
import { ChartInterval,ChartType } from "libs/types/src/lib/enums";
import { Injectable } from "@nestjs/common";
import { Charts, RRDdata } from "@ip6m/types";
const STEPTIME : number = 300; 

@Injectable()
export class RRDService{

    private rrd_datas : RRDdata[] = [];

    constructor(
        private ddmService : DDMService) {}

    updateDatabase(serial_num : string =""){

        
            if(serial_num == ""){
                Object.entries(this.ddmService.getAllDDMs).forEach(([serial_num,ddm_value]) =>{
                    if(this.isRrdExists(serial_num)){
                        this.updateRRD(serial_num,this.getUNIXNow(),ddm_value.OpticalDdmRxPower/100);
                    }
                    else{
                        this.createRRD(serial_num,this.getUNIXNow(),STEPTIME);
                    }
                })
            } else {
                var value = this.ddmService.getData(serial_num).then(value=>{
                    if(this.isRrdExists(serial_num)){
                        
                        this.updateRRD(serial_num,this.getUNIXNow(),value.OpticalDdmRxPower/100)
                    }
                    else{
                        this.createRRD(serial_num,this.getUNIXNow(),STEPTIME);
                    }
                });
            } 
    }


    getRrdData(serial_num:string,interval:ChartInterval){
        return this.setData(serial_num,interval);
    }



    getCharts(serial_num:string,interval:ChartInterval) : Promise<Charts>{
        if(!this.isRrdExists(serial_num)){
            console.log("No such rrd");
            return;
        }
        return this.generatePNG(serial_num,interval,ChartType.Signal);
    }


    private generatePNG(serial_num:string,interval:ChartInterval,chartype:ChartType):Promise<Charts>{

        return new Promise((resolve,reject)=>{
            let cmd='';
            if(chartype == ChartType.Signal){
                cmd = "rrdtool graph "+ environment.png_path+serial_num+interval+chartype+".png  --start "
                        +this.intervalTotTime(interval)[0]+" --end "+ this.intervalTotTime(interval)[1]+
                        " --slope-mode --vertical-label dB --lower-limit -36 --upper-limit 0 DEF:real"+chartype+"="+environment.rrd_path+serial_num+".rrd:"+chartype+":AVERAGE \
                        CDEF:signal=realsignal CDEF:bad=realsignal,-28,LT,realsignal,UNKN,IF CDEF:average=realsignal,-23,LT,realsignal,UNKN,IF AREA:signal#00FF00 \
                        AREA:average#FFFF00 AREA:bad#FF0000"
    
                //todo chart style for traffic and packet
            }else if(ChartType.Traffic){
                cmd = "rrdtool graph "+ environment.png_path+serial_num+interval+chartype+".png  --start "
                +this.intervalTotTime(interval)[0]+" --end "+ this.intervalTotTime(interval)[1]+
                " DEF:real"+chartype+"="+environment.rrd_path+serial_num+".rrd:"+chartype+":AVERAGE LINE2:real"+chartype+"#000000"
            } else if(ChartType.Packet){
                cmd = "rrdtool graph "+ environment.png_path+serial_num+interval+chartype+".png  --start "
                +this.intervalTotTime(interval)[0]+" --end "+ this.intervalTotTime(interval)[1]+
                " DEF:real"+chartype+"="+environment.rrd_path+serial_num+".rrd:"+chartype+":AVERAGE LINE2:real"+chartype+"#000000"
            }
    
            
            const {exec} = require("child_process")
            exec(cmd,(error, stdout, stderr) => {
            if (error) {
                    console.log(`error: ${error.message}`);
                    return reject(error);
                }
                if (stderr) {
                    console.log(`stderr: ${stderr}`);
                    return reject(error);
                }
                if(stdout){
                    return resolve({
                        signalChart: environment.client_chart_path+serial_num+interval+"signal.png",
                        trafficChart: environment.client_chart_path+serial_num+interval+"traffic.png",  
                        packetsChart: environment.client_chart_path+serial_num+interval+"packet.png"
                    });
                }
            });
        });
       
}

    private isRrdExists(serialNum : string){
    const fs = require('fs');
    const filepath = environment.rrd_path+serialNum+".rrd";
    
    try {
        if(fs.existsSync(filepath)) {
            return true;
        } else {
            return false;
        }
    } catch (err) {
        console.error(err);
        }
    }

    private setData(serial_num:string,interval:ChartInterval):Promise<RRDdata[]>{
        return new Promise((resolve,reject) =>{
            const cmd = "rrdtool fetch " +environment.rrd_path+serial_num+".rrd "+"AVERAGE --start "+this.intervalTotTime(interval)[0] +" --end " +this.intervalTotTime(interval)[1];
            
            const { exec } = require('child_process');
            exec(cmd,(error, stdout, stderr) => {
                if (error) {
                        console.log(`error: ${error.message}`);
                        return reject(error);
                    }
                    if (stderr) {
                        console.log(`stderr: ${stderr}`);
                        return reject(error);
                    }
                    const tmp = stdout.toString()
                    var data = tmp.split("\n").slice(2,tmp.split("\n").length-1)
                    var result : RRDdata[] = [];
                    data.forEach((value) => {
                        let line = value.split(" ")                        
                        result.push({
                            time : new Date(parseInt(line[0].substring(0,line[0].length-1))*1000),
                            signal: parseFloat(line[1].slice(0,6).replace(",","."))*10,
                        })                        
                    });
                    return resolve(result);
                });
            
        });
    }


    private createRRD(serial_num:string ,create_time:number,step:number){
        const cmd = "rrdtool create " +environment.rrd_path+serial_num+".rrd --start " +create_time+ " --step " + step
                    + " DS:signal:GAUGE:420:-36:0 RRA:AVERAGE:0.5:1:2020 RRA:AVERAGE:0.5:24:367 RRA:AVERAGE:0.5:288:367"
        const { exec } = require('child_process');
        exec(cmd,(error, stdout, stderr) => {
            if (error) {
                    console.error(`error: ${error.message}`);
                    return;
                }
                if (stderr) {
                    console.error(`stderr: ${stderr}`);
                    return;
                }
            });
    }

    private updateRRD(serial_num:string, time:number, signal:number){
        const cmd = "rrdtool update "+ environment.rrd_path + serial_num + ".rrd " + time + ":" +signal;
        
        
        const { exec } = require('child_process');
            
        exec(cmd,(error, stdout, stderr) => {
            if (error) {
                console.error(`error: ${error.message}`);
                return;
            }
            if (stderr) {
                console.error(`stderr: ${stderr}`);
                return;
            }
        });
    }

    private intervalTotTime(interval:ChartInterval){
        let checkmodular_minutes = new Date().getMinutes() % 5; 
        let checkmodular_hour = new Date().getHours() % 2;
        switch(interval){
            case ChartInterval.Hourly:
                return [this.getUNIXNow()-4000,checkmodular_minutes % 5 == 0 ? this.getUNIXNow()-600 : this.getUNIXNow()-300];
            case ChartInterval.Daily:
                return [this.getUNIXNow()-87000,checkmodular_minutes % 5 == 0 ? this.getUNIXNow()-600 : this.getUNIXNow()-300];
            case ChartInterval.Weekly:
                return [this.getUNIXNow()-605000,this.getUNIXNow()-600];
            case ChartInterval.Monthly:
                return [this.getUNIXNow()-2630000,this.getUNIXNow()-10800];
            case ChartInterval.Annual:
                return [this.getUNIXNow()-31622400,this.getUNIXNow()-173000];
        }
    }


    private getUNIXNow():number{
        return Math.round(new Date().getTime()/1000);
    }

}